const actionType = {
    CHANGE_UPDATE_MODAL_STATE: "CHANGE_UPDATE_MODAL_STATE",
};

export default actionType;
